import { memoizeDeep } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    listview
  } = _ref;
  let listView = {},
      listviewHeader = {},
      listviewHeaderTitle = {},
      listViewBody = {},
      emptyFeedback = {},
      listViewItem = {},
      listViewItemGroup = {},
      listViewItemContent = {},
      listViewItemHeader = {},
      listViewItemTitle = {},
      listViewItemBodyContent = {},
      listViewItemFooter = {},
      listViewItemFooterNoBorder = {},
      listViewRadioButtonHeader = {},
      expandableContainer = {},
      expandableButton = {},
      expandableButtonExpanded = {},
      expandAllButton = {},
      listViewSelectable = {},
      listViewItemNumber = {},
      listViewItemNumberHeader = {},
      listViewItemBodyExpandable = {},
      listViewItemBodySelectable = {},
      listViewItemBodyAllFeature = {},
      listViewSelectAll = {},
      listViewFooter = {};

  if (listview) {
    listView = listview.listView;
    listviewHeader = listview.listviewHeader;
    listviewHeaderTitle = listview.listviewHeaderTitle;
    listViewBody = listview.listViewBody;
    emptyFeedback = listview.emptyFeedback;
    listViewItem = listview.listViewItem;
    listViewItemGroup = listview.listViewItemGroup;
    listViewItemContent = listview.listViewItemContent;
    listViewItemHeader = listview.listViewItemHeader;
    listViewItemTitle = listview.listViewItemTitle;
    listViewItemBodyContent = listview.listViewItemBodyContent;
    listViewItemFooter = listview.listViewItemFooter;
    listViewItemFooterNoBorder = listview.listViewItemFooterNoBorder;
    listViewRadioButtonHeader = listview.listViewRadioButtonHeader;
    expandableContainer = listview.expandableContainer;
    expandableButtonExpanded = listview.expandableButtonExpanded;
    expandableButton = listview.expandableButton;
    expandAllButton = listview.expandAllButton;
    listViewSelectable = listview.listViewSelectable;
    listViewItemNumber = listview.listViewItemNumber;
    listViewItemNumberHeader = listview.listViewItemNumberHeader;
    listViewItemBodyExpandable = listview.listViewItemBodyExpandable;
    listViewItemBodySelectable = listview.listViewItemBodySelectable;
    listViewItemBodyAllFeature = listview.listViewItemBodyAllFeature;
    listViewSelectAll = listview.listViewSelectAll;
    listViewFooter = listview.listViewFooter;
  }

  return {
    listView,
    listviewHeader,
    listviewHeaderTitle,
    listViewBody,
    emptyFeedback,
    listViewItem,
    listViewItemGroup,
    listViewItemContent,
    listViewItemHeader,
    listViewItemTitle,
    listViewItemBodyContent,
    listViewItemFooter,
    listViewItemFooterNoBorder,
    listViewRadioButtonHeader,
    expandableContainer,
    expandableButton,
    expandableButtonExpanded,
    expandAllButton,
    listViewSelectable,
    listViewItemNumber,
    listViewItemNumberHeader,
    listViewItemBodyExpandable,
    listViewItemBodySelectable,
    listViewItemBodyAllFeature,
    listViewSelectAll,
    listViewFooter
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme
  } = _ref2;
  const listview = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.listview;
  return setTheme({
    listview
  });
}